import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 系统消息列表
 * 
 * @param {Array} searchData 搜索条件
 *
 * @returns {Promise<any>}
 */
$api.getSystemsMessages = function(searchData) {
	const url = 'systems-messages';
	const promise = new Promise(function(resolve){
		$http.get(url, {params: searchData}).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 系统消息阅读
 * 
 * @param {Array} data 数据
 *
 * @returns {Promise<any>}
 */
$api.readSystemMsg = function(data) {
	const url = 'systems-messages-readding';
	const promise = new Promise(function(resolve){
		$http.put(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.msg);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 推送消息列表
 * 
 * @param {Array} searchData 搜索条件
 *
 * @returns {Promise<any>}
 */
$api.getpushsMessages = function(searchData) {
	const url = 'pushs-messages';
	const promise = new Promise(function(resolve){
		$http.get(url, {params: searchData}).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 推送消息阅读
 * 
 * @param {Array} data 数据
 *
 * @returns {Promise<any>}
 */
$api.readPushsMsg = function(data) {
	const url = 'pushs-messages-readding';
	const promise = new Promise(function(resolve){
		$http.put(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.msg);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 我的推送消息列表
 * 
 * @param {Array} searchData 搜索条件
 *
 * @returns {Promise<any>}
 */
$api.getMyPushsMessages = function(searchData) {
	const url = 'my-push-messages';
	const promise = new Promise(function(resolve){
		$http.get(url, {params: searchData}).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

export default $api; 


// WEBPACK FOOTER //
// ./src/service/usercenter/messages.js